import styled from 'styled-components';
var HiddenInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "style__HiddenInput",
  componentId: "c84tu8-0"
})(["border:0;clip:rect(0 0 0 0);clip-path:inset(50%);margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;"]);
export default HiddenInput;